import { useResults } from '#pplx/frontend/apps/ask/providers/ResultsContext.js';
import { useThreadConfig } from '#pplx/frontend/apps/ask/providers/ThreadSettingsProviderShared.js';
import { isBrowserAgent } from '#pplx/frontend/ask-models/isBrowserAgent.js';
/** Shares Browser Agent mode selection and commitment policy between thread input surfaces. */
export function useBrowserAgentMode() {
    const { configuredModel } = useThreadConfig();
    const { lastResult } = useResults();
    const isBrowserAgentThread = isBrowserAgent(lastResult?.display_model);
    return {
        isBrowserAgentMode: isBrowserAgent(configuredModel) || isBrowserAgentThread,
        canClearSearchMode: !isBrowserAgentThread,
    };
}
//# sourceMappingURL=useBrowserAgentMode.js.map